export const ONBOARDING_INVITE_TEAM_FORM_ID = 'onboarding-invite-team-form';

export const ONBOARDING_INVITE_LEGACY_FORM_ID = 'onboarding-invite-legacy-form';
